import { HpArticle } from 'api3';
import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, computed, input } from '@angular/core';
import { ImageZoomDirective } from '@app/components/zoom/image-zoom-directive/image-zoom.directive';
import { TranslocoPipe } from '@jsverse/transloco';
import { MarkdownModule } from 'ngx-markdown';

@Component({
  selector: 'app-hp-renderer',
  template: `
    @for (article of articleData(); track $index) {
      <div class="pb-24">
        <markdown appImageZoom>{{ article.text }}</markdown>
      </div>
    }

    @for (text of stringData(); track $index) {
      <div class="pb-24">
        <markdown appImageZoom>{{ text }}</markdown>
      </div>
    }

    @if (!stringData() && !articleData()) {
      <p class="mt-8 text-center text-sm text-gray-500">{{ 'global.noOEDataFound' | transloco }}</p>
    }
  `,
  imports: [CommonModule, TranslocoPipe, MarkdownModule, ImageZoomDirective],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class HpRendererComponent {
  data = input<HpArticle[] | string[] | string | undefined>();

  articleData = computed(() => (this.data()?.length && typeof this.data()![0] !== 'string' ? (this.data() as HpArticle[]) : undefined));
  stringData = computed(() => {
    const data = this.data();
    if (typeof data === 'string') {
      return [data];
    }
    if (Array.isArray(data) && data.length && typeof data[0] === 'string') {
      return data;
    }
    return undefined;
  });
}
